import { createEntityAdapter, createSlice } from '@reduxjs/toolkit';
import { JSONApiDataObject, ReduxEntity } from 'Douleutaras/types';
import { BsdirSubCategoryPricing } from 'Douleutaras/types/bsdir';
import { RootState } from 'Douleutaras/redux/store';

const bsdirSubCategoryPricingsAdapter = createEntityAdapter<JSONApiDataObject<BsdirSubCategoryPricing>>({
  selectId: item => item.id
});

export const bsdirSubCategoryPricingsSlice = createSlice({
  name: 'bsdirSubCategoryPricings',
  initialState: bsdirSubCategoryPricingsAdapter.getInitialState({
    loading: false,
    error: false,
    meta: {},
    entities: {}
  } as ReduxEntity<BsdirSubCategoryPricing>),
  reducers: {
    bsdirSubCategoryPricingsAdded: (state, action) => {
      bsdirSubCategoryPricingsAdapter.setMany(state, action.payload);
    }
  }
});

export const bsdirSubCategoryPricingsSelectors = bsdirSubCategoryPricingsAdapter.getSelectors(
  (state: RootState) => state.bsdir.subCategoryPricings);
export default bsdirSubCategoryPricingsSlice.reducer;
